<template>
  <button v-if="showButton"
          @click="onUpdate"
          class="action-button update"
          >
    Update
  </button>
</template>

<script>
export default {
  name: "UpdateButton",
  props: {
    activeEditor: { type: String, required: true },
    isContentChanged: { type: Boolean, required: true },
  },
  emits: ["update-question", "close-editor"],

  computed: {
    showButton() {
      return this.activeEditor && this.isContentChanged === true;
    },

  },
  methods: {
    onUpdate() {
      this.$emit("update-question");
      this.$emit("close-editor");
    },
  },
};
</script>

<style>
.action-button {
  padding: 10px 20px;
  border: none;
  border-radius: 5px;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.3s;
  color: #fff;
}

.action-button.update {
  background-color: var(--my-links);
  width: 100%;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 15px 0;
  text-align: center;
  font-size: 18px;
  font-weight: bold;
  z-index: 1300;
  transition: transform 0.3s;
}


.action-button.update:hover {
  background-color: #007aff;
}
</style>
